import styled from 'styled-components'
import selectArrow from '../../../../assets/icons/select-arrow.png'
import {
	DISABLED,
	GRAY,
	LIGHTGRAY,
	PRIMARY_COLOR,
} from '../../../styles/colors.style'
import {
	borderRadius,
	shadow,
	textInputBorder,
	textInputShadow,
} from '../../../styles/reusable.style'
import { breakpoints } from '../../../constants'

const StyledInput = styled.div`
	${(props) => props.shadow && shadow()};
	position: relative;
	width: calc(200% / 12 - 0.8rem);

	@media (max-width: ${breakpoints.MOBILE_IFRAME_PLANALTO}px) {
		width: 100%;
	}

	input,
	textarea,
	select {
		box-sizing: border-box;
		color: ${GRAY};
		font-weight: 400;
		font-size: 16px;
		padding: 1rem;
		width: 100%;
		${(props) => !props.shadow && textInputShadow()};
		${(props) =>
			props.noBorder ? 'border: 1px solid transparent' : textInputBorder()};
		border-radius: ${borderRadius};

		&:focus {
			outline: none;
			border: 1px solid ${PRIMARY_COLOR};
		}

		&::placeholder {
			color: ${GRAY};
		}

		&:disabled {
			background-color: ${DISABLED};
		}

		&.with-icon {
			padding-left: 7.5rem;
		}
	}

	textarea {
		resize: none;
	}

	select {
		appearance: none;
		background-image: url(${selectArrow});
		background-repeat: no-repeat;
		background-position: right;

		&::-ms-expand {
			display: none;
		}
	}

	input[id^='react-select-'] {
		outline: none;
		border: none;
		box-shadow: none;
		border: none;
		width: auto;
	}

	.error {
		position: absolute;
		margin-top: 0.3rem;
		padding: 0 0 12px 0;
		width: max-content;
		max-width: max-content;
	}

	label {
		display: block;
	}

	.icon {
		z-index: 2;
		position: absolute;
		left: 7px;
		color: ${LIGHTGRAY};
		top: 50%;
		transform: translateY(-50%);
	}

	.noShadow {
		box-shadow: 1px 1px 1px red;
	}

	/*Placeholder do async select*/
	.css-1492t68 {
	}

	.css-1gl4k7y {
		font-size: 16px;
	}
`

const StyledFieldContainer = styled.div`
	position: relative;
`

const StyledLabel = styled.span`
	color: ${GRAY};
	display: block;
	font-size: 15px;
	margin-bottom: 7px;
`

const StyledDiv = styled.div`
	z-index: 1;

	${(props) => (props.full ? `width: 100%;` : '')};
`

export { StyledInput, StyledDiv, StyledFieldContainer, StyledLabel }
